import { logout } from '../auth'
import { ROUTE_LOGIN } from '../common/helpers/Paths'
import {
  saveUserEvent,
  EVENT_CATEGORY_ACCOUNT,
  EVENT_ACTION_LOGOUT
} from '../common/api/UserEvents'
import { useState, useEffect } from 'react'
import { logoutMobile } from 'components/common/helpers/Mobile'

export default function Logout({ setIsAuthenticated }) {
  const [loggedOut, setLoggedOut] = useState()

  useEffect(() => {
    // If we have any query params, we need to append them to the login route
    const searchParams = new URLSearchParams(window.location.search)

    // Return and reload if we're already logged out
    if (loggedOut) {
      const loginUrl = `${ROUTE_LOGIN}${
        searchParams.toString() ? '?' : ''
      }${searchParams.toString()}`

      window.location.href = loginUrl
      return
    }

    async function logoutAsync() {
      try {
        await saveUserEvent(EVENT_CATEGORY_ACCOUNT, EVENT_ACTION_LOGOUT)
      } catch (error) {
        // Swallow exceptions
      }
      if (setIsAuthenticated) setIsAuthenticated(false)
      setLoggedOut(true)
      logoutMobile()
      logout()
    }

    logoutAsync()
  }, [loggedOut, setIsAuthenticated])

  return null
}
